<template>
	<div class="wards__full wardfull">
		<div class="wardfull__content">
			<div class="wardfull__close">
				<span uk-icon="close" @click="$emit('closeFullWard')"></span>
			</div>
			<div class="wardfull__person">
				<h5>Информация о пользователе:</h5>
				<p>
					<small>Имя:</small>
					{{ user.name }}
				</p>
				<p v-if="user.property && user.property.organization">
					<small>Организация:</small>
					{{ user.property.organization }}
				</p>
				<p>
					<small>Email:</small>
					{{ user.email }}
				</p>
				<h5>Заказы:</h5>
				<div class="wardfull__orders" v-if="orders.length > 0">
					<ul uk-accordion="">
						<li v-for="order in orders" class="wardfull__order">
							<a class="uk-accordion-title" href="#"><span>Заказ от</span> {{ order.created_at }},
								<span>Статус:</span> {{ order.status }}</a>
							<div class="uk-accordion-content">
								<div class="order_details">
									<div class="order_details__wrap">
										<p>
											<small>Оплата:</small>
											{{ order.pay_type}}
										</p>
										<p>
											<small>Сумма заказа:</small>
											{{ order.total | cifer }} рублей
										</p>
									</div>
									<p><small>Состав заказа:</small></p>
									<ul class="uk-child-width-1-2 uk-child-width-1-4@s uk-child-width-1-5@m uk-grid-match uk-grid-small order_details__goods" uk-grid>
										<li v-for="good in order.order_details">
											<div class="order_details__item">
												<div class="order_details__image">
													<img :src="good.currentColor.image.path" alt="">
												</div>
												<div class="order_details__content">
													<p><strong>Бренд:</strong> {{ good.seria.brand.title }}</p>
													<p><strong>Серия:</strong> {{ good.seria.title }}</p>
													<p><strong>Модель:</strong> {{ good.title }}</p>
													<p><strong>Цвет:</strong> {{ good.currentColor.title }}</p>
													<p><strong>Количество:</strong> {{ good.count }}</p>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div v-else>
					<p>Пользователь пока не делал заказы</p>
				</div>
			</div>
		</div>
		<wait></wait>
	</div>
</template>

<script>
  import { bus } from './bus.js'
  import wait from './wait'

  export default {
    name: "ward-full",
    data() {
      return {
        user: '',
        orders: ''
      }
    },
    components: { wait },
    props: {
      item: ''
    },
    methods: {
      getUserInfo() {
        let app = this;

        $.request('onGetUserInfo', {
          data: {
            user_id: this.item.id
          },
          success: function (data) {
            console.log(data);
            app.user = data.user;
            app.orders = data.orders;
            bus.$emit('wait', false);
          },
          error: function (err) {
            console.log(err);
          }
        });
      }
    },
    mounted() {
      bus.$emit('wait', true);
      this.getUserInfo();
    },
    created() {
      console.log('Йа родился!');
      $('body').addClass('fixed');
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/ward-full.vue